import { Colors } from './styled'

/**
 * Deep Space — carbón #020618, acento mint #00e8a3, CTA amarillo #ffea80.
 */
export function paletteDeepSpace(darkMode: boolean): Colors {
  const white = '#FFFFFF'
  const black = '#000000'

  if (!darkMode) {
    return {
      white,
      black,
      text1: '#0f172b',
      text2: '#1e293b',
      text3: '#64748b',
      text4: '#94a3b8',
      text5: '#cbd5e1',
      bg1: '#f8fafc',
      bg2: '#f1f5f9',
      bg3: '#e2e8f0',
      bg4: '#cbd5e1',
      bg5: '#ffffff',
      modalBG: 'rgba(15, 23, 43, 0.35)',
      advancedBG: 'rgba(0, 232, 163, 0.06)',
      primary1: '#0d9488',
      primary2: '#14b8a6',
      primary3: '#0f766e',
      primary4: '#ccfbf1',
      primary5: 'rgba(13, 148, 136, 0.12)',
      primaryText1: '#ffffff',
      secondary1: '#0f172b',
      secondary2: '#0f172b',
      secondary3: '#0f172b',
      red1: '#FF6871',
      red2: '#F82D3A',
      green1: '#00a37a',
      yellow1: '#0a0a12',
      yellow2: '#ca8a04',
      panelShell: '#f8fafc',
      panelShellMuted: '#f1f5f9',
      panelInset: '#ffffff',
      panelRow: '#f1f5f9',
      panelBorder: '#e2e8f0',
      panelControlBg: '#e2e8f0',
      ctaBg: '#ffea80',
      ctaText: '#0a0a12'
    }
  }

  return {
    white,
    black,
    text1: '#f1f5f9',
    text2: '#e2e8f0',
    text3: '#94a3b8',
    text4: '#64748b',
    text5: '#475569',
    bg1: '#1e293b',
    bg2: '#01040f',
    bg3: '#334155',
    bg4: '#475569',
    bg5: '#0a0a12',
    modalBG: 'rgba(2, 6, 24, 0.82)',
    advancedBG: 'rgba(0, 232, 163, 0.06)',
    primary1: '#00e8a3',
    primary2: '#5ee9b5',
    primary3: '#00bc7d',
    primary4: '#0a0a12',
    primary5: 'rgba(0, 232, 163, 0.12)',
    primaryText1: '#0a0a12',
    secondary1: '#020618',
    secondary2: '#020618',
    secondary3: '#020618',
    red1: '#FF6871',
    red2: '#F82D3A',
    green1: '#00e8a3',
    yellow1: '#f1f5f9',
    yellow2: '#ffea80',
    panelShell: 'rgba(30, 41, 55, 0.4)',
    panelShellMuted: 'rgba(30, 41, 55, 0.3)',
    panelInset: 'rgba(10, 10, 18, 0.6)',
    panelRow: 'rgba(10, 10, 18, 0.4)',
    panelBorder: '#1e2937',
    panelControlBg: 'rgba(30, 41, 55, 0.5)',
    ctaBg: '#ffea80',
    ctaText: '#0a0a12'
  }
}
